import { render, staticRenderFns } from "./AlertsContainer.vue?vue&type=template&id=3ac4cba3&"
import script from "./AlertsContainer.vue?vue&type=script&lang=js&"
export * from "./AlertsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports